






































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import AsideTools from '@/components/Layout/AsideTools.vue'
import AsideMenuList from '@/components/Layout/AsideMenuList.vue'

@Component({
  computed: {
    ...mapState([
      'isAsideVisible', 'isAsideExpanded', 'activeSubmenu'
    ])
  },
  methods: {
    ...mapActions([
      'openSubmenu', 'hideSubmenu'
    ])
  },
  components: { AsideTools, AsideMenuList }
})
export default class AsideMenu extends Vue {

  @Prop({ type: Array, default: []}) menu!: any[];

  menuClick (item: any) {
    //
  }

  closeSubmenu() {
    this.$store.commit('hideSubmenu')
  }

}

